export default __webpack_public_path__ + "media/hi-there-bg.b2aed44e.png";